export default __webpack_public_path__ + "static/top-c2ecc81ef6098cf06b39b42935a42f34.png";